/**
 * Firebase web app config.
 *
 * These values are NOT secrets — the Firebase web config is public by design.
 * Security is enforced by Firestore rules (owner-only `users/{uid}`) and the
 * Authentication "Authorized domains" list, not by hiding this object.
 *
 * Fill in from Firebase console → Project settings → Your apps → Web app.
 * Until `apiKey` is set, the auth/cloud-sync UI stays disabled and the app
 * runs fully on local storage.
 */
export const firebaseConfig = {
  apiKey: 'AIzaSyAFMphJLoSsTFAw8qzpU1vSy2IiIrC1DNg',
  authDomain: 'sword-academy.firebaseapp.com',
  projectId: 'sword-academy',
  storageBucket: 'sword-academy.firebasestorage.app',
  messagingSenderId: '1096852784270',
  appId: '1:1096852784270:web:a61134afece7bbdef235df',
} as const;

/** True once the web config has been filled in (gates all Firebase usage). */
export function isFirebaseConfigured(): boolean {
  return firebaseConfig.apiKey.trim().length > 0 && firebaseConfig.appId.trim().length > 0;
}
